let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kNyWt")).then(() => parcelRequire('77KIU'));